import ajax from './ajax'

//获取分享页
export const getDetail = (id) => ajax({
  url: `/coursera/share/course/detail/${id}`,
  // params: {
  //     id,
  //   }
})

export const getContent = (type,corpId) => ajax({
  url: `/coursera/common/protocol/list/${type}/${corpId}`,
  // params: {/coursera/common/protocol/list/{type}
  //     type,
  //   }
})

export const getClassesDetail = (id) => ajax({
  url: `/coursera/share/classes/detail/${id}`,
  // params: {/coursera/common/protocol/list/{type}
  //     type,
  //   }
})

export const getNotifiNoticeDetail = (id) => ajax({
  url: '/coursera/notifiNotice/detail',
  params: {
      id,
    }
})

//考场同步
export const examSync = (data) => ajax({
    url: '/coursera/common/user/exam/sync',
    method: 'post',
    data
  })
// 发送验证
  export const sendMsg = (data) => ajax({
    url: `/coursera/common/user/send/msg`,
    method: 'post',
    data
  })
